import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { Dialog } from '../components/DialogOld';
import { saveMacro } from '../actions/SaveMacro';
import { createMacro } from '../actions/CreateMacro';
import { deleteMacro } from '../actions/DeleteMacro';
import { FormGroup } from '../components/FormGroup';
import { FormRow } from '../components/FormRow';
import { TransmitterSelector } from '../components/TransmitterSelector';
import { OperationSelector } from '../components/OperationSelector';
import { hideDialog } from '../reducers/app';
import { get_any_transmitter_id } from '../util/definitions';
import { editMacroDialogAddItem, editMacroDialogDeleteItem, editMacroDialogItemChange, editMacroDialogItemTransmitterChange, setMacroDialogActive, setMacroDialogTitle } from '../reducers/edit_macro_dialog';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa scen" }));
export function DialogMacroEdit() {
    const dispatch = useAppDispatch();
    const edit_macro_dialog = useAppSelector(state => state.edit_macro_dialog);
    const devices = useAppSelector(state => state.definitions.devices);
    const definitions = useAppSelector(state => state.definitions);
    let footerleft, footerright;
    const items = edit_macro_dialog.items ? edit_macro_dialog.items : [];
    if (edit_macro_dialog.id) {
        footerleft = [
            (_jsx(DeleteButton, { onClick: () => dispatch(deleteMacro()) }, "delete"))
        ];
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(SaveButton, { onClick: () => dispatch(saveMacro()) }, "save"))
        ];
    }
    else {
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(CreateButton, { onClick: () => dispatch(createMacro()) }, "create"))
        ];
    }
    const addItem = _event => {
        const default_transmitter_id = get_any_transmitter_id(definitions);
        if (default_transmitter_id == undefined) {
            return;
        }
        let default_transmitter_operation;
        const device = devices[default_transmitter_id];
        if (device == undefined) {
            return;
        }
        switch (device.transmitter_kind) {
            case 'onoff':
                default_transmitter_operation = 'off';
                break;
            case 'dim':
                default_transmitter_operation = 'dim 15';
                break;
        }
        if (default_transmitter_operation == undefined) {
            return;
        }
        dispatch(editMacroDialogAddItem(default_transmitter_id, default_transmitter_operation));
    };
    const updateActiveField = (event) => {
        dispatch(setMacroDialogActive(event.target.checked));
    };
    const updateTitleField = (event) => {
        dispatch(setMacroDialogTitle(event.target.value));
    };
    const updateItemField = (index) => (event) => {
        if (event.target.type == 'select-one') {
            dispatch(editMacroDialogItemChange(index, { operation: event.target.value }));
        }
    };
    const updateTransmitter = (index) => (event) => {
        const device_id = Number(event.target.value);
        const d = devices[device_id];
        let op;
        switch (d.transmitter_kind) {
            case 'onoff':
                op = 'off';
                break;
            case 'dim':
                op = 'dim 15';
                break;
            case 'rollershade':
                op = 'up';
                break;
            case 'garage':
                op = 'off';
                break;
            default:
                op = '';
                break;
        }
        dispatch(editMacroDialogItemTransmitterChange(index, device_id, op));
    };
    const itemsnodes = items.map((item, index) => (_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '7fr 4fr 1fr', paddingBottom: '7px' }, children: [_jsx("div", { style: { paddingRight: '15px' }, children: _jsx(TransmitterSelector, { name: "transmitter_id", value: item.transmitter_id, onChange: updateTransmitter(index) }) }), _jsx("div", { children: _jsx(OperationSelector, { name: "operation", transmitter_id: item.transmitter_id, value: item.operation, onChange: updateItemField(index) }) }), _jsx("div", { style: { justifySelf: 'right' }, children: _jsx("button", { type: "button", className: "close", "aria-label": "Close", style: { paddingTop: '5px' }, onClick: () => dispatch(editMacroDialogDeleteItem(index)), children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) }) })] }, index)));
    return (_jsxs(Dialog, { id: "macro-edit", title: "Redigera scen", footerleft: footerleft, footerright: footerright, children: [_jsx("input", { name: "macro_id", type: "hidden", value: edit_macro_dialog.id }), _jsx(FormGroup, { label: "Namn", children: _jsx("input", { type: "text", name: "title", value: edit_macro_dialog.title, onChange: updateTitleField }) }), _jsx(FormRow, { children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "active", checked: edit_macro_dialog.active, onChange: updateActiveField }), "\u00A0Aktiv"] }) }), itemsnodes, _jsx(FormRow, { children: _jsx("button", { className: "lw success add-command", onClick: addItem, children: "L\u00E4gg till kommando..." }) })] }));
}
